// Lib
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { openModal, closeModal } from 'actions/modal';

const useModal = () => {
  const dispatch = useDispatch();
  const modal = useSelector<any, any>(state => state.modal);

  const openModalHandler = useCallback(
    ({ title, data }: { title: string; data?: any }) => () => {
      dispatch(openModal({ title, data }));
    },
    [dispatch]
  );
  const closeModalHandler = useCallback(() => dispatch(closeModal()), [dispatch]);

  return { openModalHandler, closeModalHandler, title: modal.title };
};

export default useModal;
